import clsx from 'clsx';
import Tooltip from '@material-ui/core/Tooltip';
import useStyles from '@common_tooltipseller/style';

const TooltipSeller = (props) => {
    const className = useStyles();

    const {
        arrow = true, title = '', classes = {}, children, placement = 'top', ...rest
    } = props;

    const {
        tooltip: tooltipClasses,
        tooltipPlacementBottom: tooltipPlacementBottomClasses,
        tooltipPlacementTop: tooltipPlacementTopClasses,
        arrow: arrowClasses,
        ...restClasses
    } = classes;

    return (
        <Tooltip
            arrow={arrow}
            title={title}
            placement={placement}
            classes={{
                tooltip: clsx(className.tooltip, tooltipClasses),
                tooltipPlacementBottom: clsx(className.tooltipPlacementBottom, tooltipPlacementBottomClasses),
                tooltipPlacementTop: clsx(className.tooltipPlacementTop, tooltipPlacementTopClasses),
                arrow: clsx(className.arrow, arrowClasses),
                ...restClasses,
            }}
            {...rest}
        >
            {children || <img src="/assets/img/information-circle.svg" alt="tooltip" className={className.tooltipImg} />}
        </Tooltip>
    );
};

export default TooltipSeller;
